import { useTranslation } from 'react-i18next';
import { formatCurrency, formatNumber, formatDate, formatPercentage, getCurrentLocale } from '../utils/formatters';

/**
 * Hook for language-aware formatting
 * Provides formatting functions that automatically use the current language locale
 */
export const useFormatters = () => {
  const { i18n } = useTranslation();

  const currentLocale = getCurrentLocale();

  return {
    // Currency formatting with current locale
    formatCurrency: (amount: number, currency = 'USD') => formatCurrency(amount, currency, currentLocale),

    // Number formatting with current locale
    formatNumber: (number: number) => formatNumber(number, currentLocale),

    // Percentage formatting with current locale
    formatPercentage: (value: number) => formatPercentage(value, currentLocale),

    // Date formatting with current locale
    formatDate: (date: Date | string) => formatDate(date, currentLocale),

    // Get current locale
    getCurrentLocale: () => currentLocale,

    // Get current language
    getCurrentLanguage: () => i18n.language,

    // Check if current language is RTL
    isRTL: () => ['he', 'ar', 'fa', 'ur'].includes(i18n.language),
  };
};
